import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { PageShell } from '../components/PageShell.tsx';
import { getHealth, type Health } from '../lib/health.ts';

export function StatusPage() {
  const intl = useIntl();
  const [health, setHealth] = useState<Health | Error | null>(null);

  useEffect(() => {
    void getHealth().then(setHealth, () => {
      setHealth(new Error('health'));
    });
  }, []);

  const status =
    health instanceof Error ? 'unavailable' : (health?.status ?? 'checking');

  return (
    <PageShell projectName="link">
      <h1 className="m-0 text-[clamp(2.4rem,7vw,4.5rem)] leading-[0.98] font-semibold tracking-[-0.045em]">
        {intl.formatMessage({ id: 'web.status.title' })}
      </h1>
      <p className="my-8 max-w-[31rem] text-lg leading-relaxed text-muted-foreground">
        {intl.formatMessage({ id: 'web.status.description' })}
      </p>
      <div className="inline-flex w-fit items-center gap-2.5 rounded-lg border border-border bg-card px-3 py-2.5 text-sm shadow-[0_6px_12px_rgb(23_22_20_/_0.06)]">
        <span className="size-2 rounded-full bg-foreground" />
        {intl.formatMessage(
          { id: 'web.health.status' },
          {
            status: intl.formatMessage({ id: `web.health.${status}` }),
          },
        )}
      </div>
    </PageShell>
  );
}
